import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ConfirmDialog = ({ open, name, target, confirm, close }) => {
    return (
        <Dialog
            open={open}
            onClose={close}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Är du säker?
            </DialogTitle>
            <DialogContent>
                {(target !== null && target !== undefined) && <DialogContentText id="alert-dialog-description">
                    Är du säker på att du vill avboka <strong>{name}</strong> för <strong>{target}</strong>
                </DialogContentText>}
                {(target === null || target === undefined) && <DialogContentText id="alert-dialog-description">
                    Är du säker på att du vill avboka <strong>{name}</strong>
                </DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button onClick={close}>Nej</Button>
                <Button onClick={confirm} autoFocus>
                    Ja
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog